import type { DashboardTabItem } from '../types';

const getDashboardTabItems = (): DashboardTabItem[] => [
    { tabId: 'summary', label: 'Summary' },
    { tabId: 'growth', label: 'Growth' },
    { tabId: 'unit-economics', label: 'Unit economics' },
    { tabId: 'retention', label: 'Retention' },
    { tabId: 'engagement', label: 'Engagement' },
    { tabId: 'organizations', label: 'Organizations' },
];

export default getDashboardTabItems;
